export type ChapiPose =
  | 'hello' | 'happy' | 'thinking' | 'working' | 'searching' | 'done' | 'oops' | 'sorry' | 'sleeping' | 'thank-you'
  | 'tasks' | 'time' | 'calendar' | 'projects' | 'clients' | 'assistant';

/** Chapi, from the character kit (packages/ui-tokens/brand/chapi). Decorative unless given a label. */
export function Chapi({ pose = 'hello', size = 96, label }: { pose?: ChapiPose; size?: number; label?: string }) {
  return <img className="chapi-img" src={`/chapi/${pose}.png`} width={size} height={Math.round(size * 1.2)} style={{ objectFit: 'contain' }} alt={label ?? ''} aria-hidden={!label} />;
}
